export default {
  'Processo/Contrato finalizado': 1,
  'Sem retorno': 2,
  'Renovado com outro corretor': 3,
  'Outros': 4
}
